// extracted by mini-css-extract-plugin
module.exports = {"root":"ScheduleCursor_root__9eupa","active":"ScheduleCursor_active__PvOFO"};